module.exports = __webpack_public_path__ + "static/media/message.2b00d1b2.svg";